// src/components1/Header.js
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import pocketappslogo from "../images/pocketappslogo.png";
import "../styles/Header.css";

const Header = ({ title }) => {
  const [fullName, setFullName] = useState("");
  const location = useLocation();

  useEffect(() => {
    try {
      const sessionUser = JSON.parse(localStorage.getItem("loggedInUser"));
      const guestUser = JSON.parse(localStorage.getItem("guestUser"));
      const isRealUser = sessionUser && sessionUser.email && sessionUser.email !== "guest" && sessionUser.email.includes("@");
      const user = isRealUser ? sessionUser : guestUser;
      if (user && user.name && user.name !== "guest") {
        setFullName(user.name); // Full name
      } else if (isRealUser && sessionUser?.email) {
        const namePart = sessionUser.email.split("@")[0];
        setFullName(namePart);
      } else if (guestUser) {
        setFullName("Guest");
      } else {
        setFullName("User");
      }
    } catch {
      setFullName("User");
    }
  }, []);

  const [isRefreshing, setIsRefreshing] = useState(false);
  const isProfileActive = location.pathname.includes("/app1/profile");

  const handleRefreshClick = () => {
    if (isRefreshing) return;
    setIsRefreshing(true);

    // If on shared expense, clear the cache so it forces a full fresh pull from server
    try {
      const sessionUser = JSON.parse(localStorage.getItem("loggedInUser"));
      if (sessionUser?.email) {
        localStorage.removeItem(`shared_expense_cache_${sessionUser.email.toLowerCase()}`);
      }
    } catch (e) {}

    // Dispatch refresh request across listening pages
    window.dispatchEvent(
      new CustomEvent("app-manual-refresh", { detail: { pathname: location.pathname } })
    );

    setTimeout(() => {
      setIsRefreshing(false);
    }, 850);
  };

  return (
    <header className="header-container">
      <Link to="/app1/home" className="header-brand-wrap" style={{ textDecoration: "none" }}>
        <div className="header-brand-logo-wrap">
          <img src={pocketappslogo} alt="Pocket Expenses" className="header-brand-logo" />
        </div>
        <div className="header-brand-text-wrap">
          <span className="header-brand-title">
            Pocket Expenses
            {process.env.REACT_APP_ENV === "QA" && <span className="header-qa-badge">.</span>}
          </span>
          <span className="header-welcome-sub">
            Welcome, {fullName}
          </span>
        </div>
      </Link>

      <div className="header-actions">
        <button
          type="button"
          className={`header-icon-btn ${isRefreshing ? "spinning" : ""}`}
          onClick={handleRefreshClick}
          title="Refresh Data"
          aria-label="Refresh Data"
        >
          <i className="fi fi-rr-refresh"></i>
        </button>
        <Link
          to="/app1/profile"
          className={`header-icon-btn ${isProfileActive ? "active" : ""}`}
          title={`Profile (${fullName || "User"})`}
          aria-label="Profile"
        >
          <i className="fi fi-rr-user"></i>
        </Link>
      </div>
    </header>
  );
};

export default Header;
